import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { animation, keyframes, respondToRange } from "@animech/ui";

export const Root = styled.img`
	${({ theme }) => css`
		${animation({
			keyframes: keyframes.fadeIn(),
			duration: 150,
			timingFunction: theme.animations.timingFunctions.default,
			fillMode: "backwards",
		})}
		position: absolute;
		top: ${theme.app.logo.marginVertical};
		left: 50%;
		/* + 0.5 prevents blur caused by sub-pixel positioning */
		transform: translateX(calc(-50% + 0.5px));
		height: ${theme.app.logo.height};

		${respondToRange(theme, "tablet", "down")} {
			top: ${theme.app.logo.mobileMarginVertical};
		}
	`}
`;
